module.exports = __webpack_public_path__ + "img/icon4-1-1024x1024.fb626c5b.png";